import React, { memo } from "react";
import Text from "@ui/Text";
import { css } from "@linaria/core";
import { SEQUENTIAL_COLORS } from "./utils/mark";
import { colors, spacings } from "@ui/Theme";

export const ScatterContinuousLegend = memo(ScatterContinuousLegendC);

function ScatterContinuousLegendC({
  startLabel,
  midLabel,
  endLabel,
}: {
  startLabel: string;
  midLabel: string;
  endLabel: string;
}) {
  return (
    <div className={scatterContinuousLegend}>
      <Text type="body2SemiBold" className={scatterContinuousLabel}>
        {startLabel}
      </Text>
      <Text type="body2SemiBold" className={scatterContinuousLabel}>
        {midLabel}
      </Text>
      <Text type="body2SemiBold" className={scatterContinuousLabel}>
        {endLabel}
      </Text>
      <div className={scatterContinuousGradient} />
    </div>
  );
}

//#region CSS
const scatterContinuousLegend = css`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 16px;
  width: 360px;
  margin-left: auto;
  color: ${colors.carbon800};
  row-gap: ${spacings.xxs};
  margin-top: ${spacings.xs};
`;

const scatterContinuousLabel = css`
  grid-row: 1 / span 1;

  &:nth-child(1) {
    grid-column: 1 / span 1;
    justify-self: start;
  }
  &:nth-child(2) {
    grid-column: 2 / span 1;
    justify-self: center;
  }
  &:nth-child(3) {
    grid-column: 3 / span 1;
    justify-self: end;
  }
`;

const scatterContinuousGradient = css`
  background: linear-gradient(
    to left,
    rgb(${Object.values(SEQUENTIAL_COLORS.start).join(", ")}),
    rgb(${Object.values(SEQUENTIAL_COLORS.end).join(", ")})
  );
  grid-column: 1 / span 3;
  grid-row: 2 / span 1;
  border-radius: 1px;
`;
//#endregion CSS
